import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmRemoveFromBasketDelegator {
	constructor() {
		this.type = GtmTrackingType.REMOVE_FROM_BASKET;
		this.dataMapper = [
			{
				useDataValueFrom: 'skuID',
				gtmKey: 'id',
			},
			{
				useDataValueFrom: 'skuQty',
				gtmKey: 'quantity',
			},
			{
				useDataValueFrom: 'skuTitle',
				gtmKey: 'name',
			},
			{
				useDataValueFrom: 'skuPriceexVAT',
				gtmKey: 'price',
			},
			{
				useDataValueFrom: 'skuCategory',
				gtmKey: 'category',
			},
			{
				useDataValueFrom: 'indexIterator',
				gtmKey: 'position',
			},
			{
				useDataValueFrom: '',
				gtmKey: 'brand',
			},
			{
				useDataValueFrom: '',
				gtmKey: 'variant',
			},
		];
	}

	getTrackingData(target) {
		const objWithQuantity = Object.assign(
			{},
			TrackingHelperInstance.mapDataViaGtmKey(target, this.dataMapper),
		);

		return {
			event: 'removeFromCart',
			ecommerce: {
				remove: {
					actionField: {
						list: TrackingHelperInstance.generateActionFieldString(),
					},
					products: [objWithQuantity],
				},
			},
		};
	}
}

const GtmRemoveFromBasketDelegatorInstance = new GtmRemoveFromBasketDelegator();
export default GtmRemoveFromBasketDelegatorInstance;

// for test purpose only
export const GtmRemoveFromBasketDelegatorClass = GtmRemoveFromBasketDelegator;
